const URL_PREFIX = process.env.NODE_ENV === 'development' ? '' : '';

export default URL_PREFIX;
